/**
 * Indian City Coordinates Database
 * 
 * Comprehensive mapping of Indian city names to their coordinates [longitude, latitude]
 * Used for displaying TL locations on the India map.
 * 
 * Format: { 'CityName': [longitude, latitude] }
 * 
 * When adding a new city, just add it to the appropriate section below.
 */

// All major Indian cities with coordinates
export const INDIAN_CITY_COORDINATES = {
    // ===== METROS & TIER 1 CITIES =====
    'Mumbai': [72.8777, 19.0760],
    'Bombay': [72.8777, 19.0760], // Alias
    'Delhi': [77.1025, 28.7041],
    'New Delhi': [77.2090, 28.6139],
    'Bangalore': [77.5946, 12.9716],
    'Bengaluru': [77.5946, 12.9716], // Alias
    'Hyderabad': [78.4867, 17.3850],
    'Chennai': [80.2707, 13.0827],
    'Madras': [80.2707, 13.0827], // Alias
    'Kolkata': [88.3639, 22.5726],
    'Calcutta': [88.3639, 22.5726], // Alias
    'Ahmedabad': [72.5714, 23.0225],
    'Pune': [73.8567, 18.5204],

    // ===== IIT CITIES =====
    'Kharagpur': [87.3119, 22.3460],
    'Kanpur': [80.3319, 26.4499],
    'Roorkee': [77.8963, 29.8543],
    'Guwahati': [91.7362, 26.1445],
    'Gandhinagar': [72.6369, 23.2156],
    'Indore': [75.8577, 22.7196],
    'Ropar': [76.5336, 30.9660],
    'Rupnagar': [76.5336, 30.9660], // Alias
    'Bhubaneswar': [85.8245, 20.2961],
    'Jodhpur': [73.0243, 26.2389],
    'Patna': [85.1376, 25.5941],
    'Mandi': [76.9314, 31.7084],
    'Tirupati': [79.4192, 13.6288],
    'Palakkad': [76.6548, 10.7867],
    'Dharwad': [75.0078, 15.4589],
    'Jammu': [74.8570, 32.7266],
    'Goa': [73.8278, 15.4909],
    'Bhilai': [81.4296, 21.1938],
    'Dhanbad': [86.4304, 23.7957],

    // ===== NIT CITIES =====
    'Warangal': [79.5941, 17.9689],
    'Trichy': [78.7047, 10.7905],
    'Tiruchirappalli': [78.7047, 10.7905], // Alias
    'Surathkal': [74.7937, 13.0107],
    'Mangalore': [74.8560, 12.9141],
    'Calicut': [75.7804, 11.2588],
    'Kozhikode': [75.7804, 11.2588], // Alias
    'Kurukshetra': [76.8606, 29.9695],
    'Jamshedpur': [86.2029, 22.8046],
    'Rourkela': [84.8536, 22.2604],
    'Durgapur': [87.3119, 23.5204],
    'Allahabad': [81.8463, 25.4358],
    'Prayagraj': [81.8463, 25.4358], // Alias
    'Surat': [72.8311, 21.1702],
    'Jaipur': [75.7873, 26.9124],
    'Raipur': [81.6296, 21.2514],
    'Silchar': [92.7789, 24.8333],
    'Hamirpur': [76.5217, 31.6862],
    'Jalandhar': [75.5762, 31.3260],
    'Srinagar': [74.7973, 34.0837],
    'Agartala': [91.2868, 23.8315],
    'Aizawl': [92.7176, 23.7271],

    // ===== BITS CAMPUSES =====
    'Pilani': [75.6042, 28.3673],

    // ===== STATE CAPITALS & MAJOR CITIES =====
    'Lucknow': [80.9462, 26.8467],
    'Bhopal': [77.4126, 23.2599],
    'Chandigarh': [76.7794, 30.7333],
    'Thiruvananthapuram': [76.9366, 8.5241],
    'Trivandrum': [76.9366, 8.5241], // Alias
    'Shimla': [77.1734, 31.1048],
    'Dehradun': [78.0322, 30.3165],
    'Ranchi': [85.3096, 23.3441],
    'Dispur': [91.7882, 26.1408],
    'Imphal': [93.9368, 24.8170],
    'Shillong': [91.8933, 25.5788],
    'Kohima': [94.1086, 25.6751],
    'Itanagar': [93.6053, 27.0844],
    'Gangtok': [88.6065, 27.3389],
    'Panaji': [73.8278, 15.4909],
    'Kavaratti': [72.6358, 10.5593],
    'Port Blair': [92.7265, 11.6234],
    'Puducherry': [79.8083, 11.9416],
    'Pondicherry': [79.8083, 11.9416], // Alias

    // ===== TIER 2 CITIES =====
    'Coimbatore': [76.9558, 11.0168],
    'Kochi': [76.2673, 9.9312],
    'Cochin': [76.2673, 9.9312], // Alias
    'Ernakulam': [76.2673, 9.9312], // Alias
    'Visakhapatnam': [83.2185, 17.6868],
    'Vizag': [83.2185, 17.6868], // Alias
    'Vijayawada': [80.6480, 16.5062],
    'Nagpur': [79.0882, 21.1458],
    'Nashik': [73.7898, 19.9975],
    'Vadodara': [73.1812, 22.3072],
    'Baroda': [73.1812, 22.3072], // Alias
    'Rajkot': [70.8022, 22.3039],
    'Ludhiana': [75.8573, 30.9010],
    'Amritsar': [74.8723, 31.6340],
    'Agra': [78.0081, 27.1767],
    'Varanasi': [82.9739, 25.3176],
    'Banaras': [82.9739, 25.3176], // Alias
    'Mysuru': [76.6394, 12.2958],
    'Mysore': [76.6394, 12.2958], // Alias
    'Hubli': [75.1240, 15.3647],
    'Belgaum': [74.5006, 15.8497],
    'Belagavi': [74.5006, 15.8497], // Alias
    'Mangaluru': [74.8560, 12.9141],
    'Gulbarga': [76.8343, 17.3297],
    'Kalaburagi': [76.8343, 17.3297], // Alias
    'Madurai': [78.1198, 9.9252],
    'Salem': [78.1460, 11.6643],
    'Tiruvallur': [79.9086, 13.1431],
    'Vellore': [79.1325, 12.9165],
    'Thanjavur': [79.1378, 10.7870],
    'Tanjore': [79.1378, 10.7870], // Alias

    // ===== TIER 3 CITIES & TOWNS =====
    'Moradabad': [78.7733, 28.8386],
    'Aligarh': [78.0880, 27.8974],
    'Bareilly': [79.4304, 28.3670],
    'Meerut': [77.7064, 28.9845],
    'Gorakhpur': [83.3732, 26.7606],
    'Nainital': [79.4636, 29.3803],
    'Haridwar': [78.1642, 29.9457],
    'Rishikesh': [78.2676, 30.0869],
    'Mussoorie': [78.0644, 30.4598],
    'Udaipur': [73.7125, 24.5854],
    'Bikaner': [73.3119, 28.0229],
    'Ajmer': [74.6399, 26.4499],
    'Kota': [75.8648, 25.2138],
    'Gwalior': [78.1828, 26.2183],
    'Jabalpur': [79.9864, 23.1815],
    'Ujjain': [75.7885, 23.1765],
    'Ratlam': [75.0373, 23.3315],
    'Bhavnagar': [72.1519, 21.7645],
    'Jamnagar': [70.0577, 22.4707],
    'Junagadh': [70.4579, 21.5222],
    'Anand': [72.9289, 22.5645],
    'Mehsana': [72.3871, 23.5880],
    'Bharuch': [72.9959, 21.7051],

    // ===== UNIVERSITY TOWNS =====
    'Santiniketan': [87.6855, 23.6783],
    'Manipal': [74.7937, 13.3525],
    'Amravati': [77.7523, 16.5410],
    'Wardha': [78.6022, 20.7453],
    'Patiala': [76.3869, 30.3398],
    'Thanesar': [76.8171, 29.9738],

    // ===== LESSER KNOWN BUT IMPORTANT =====
    'Loni': [73.5267, 19.6333],
    'Pravara': [74.5006, 19.4285], // Near Loni
    'Narsapur': [81.1005, 16.4344],
    'Karaikudi': [78.7752, 10.0739],
    'Anantapur': [77.5994, 14.6819],
    'Nellore': [79.9865, 14.4426],
    'Srikakulam': [83.8962, 18.2949],
    'Rayagada': [83.4167, 19.1711],
    'Bhimavaram': [81.5212, 16.5449],
    'Kakinada': [82.2475, 16.9891],
    'Machilipatnam': [81.1303, 16.1875],
    'Guntur': [80.4365, 16.3067],
    'Kurnool': [78.0373, 15.8281],
    'Kadapa': [78.8242, 14.4674],
    'Tiruppur': [77.3411, 11.1085],
    'Erode': [77.7172, 11.3410],
    'Karur': [78.0766, 10.9601],
    'Dindigul': [77.9803, 10.3624],
    'Nagercoil': [77.4119, 8.1833],
    'Tuticorin': [78.1348, 8.7642],
    'Thoothukudi': [78.1348, 8.7642], // Alias

    // ===== NORTHEAST CITIES =====
    'Dibrugarh': [95.0088, 27.4728],
    'Jorhat': [94.2026, 26.7465],
    'Tezpur': [92.7926, 26.6338],
    'Nagaon': [92.6840, 26.3507],
    'Dimapur': [93.7266, 25.9065],
    'Tura': [90.2169, 25.5204],

    // ===== HIMALAYAN CITIES =====
    'Leh': [77.5771, 34.1526],
    'Kargil': [76.1349, 34.5539],
    'Dharamshala': [76.3234, 32.2190],
    'Manali': [77.1887, 32.2396],
    'Kullu': [77.1095, 31.9579],
    'Solan': [77.0967, 30.9045],
    'Palampur': [76.5366, 32.1109],
    'Chamba': [76.1258, 32.5534],
    'Una': [76.2708, 31.4685],
    'Bilaspur': [76.7608, 31.3324],
    'Nahan': [77.2944, 30.5596],
    'Almora': [79.6628, 29.5971],
    'Pithoragarh': [80.2181, 29.5829],
    'Haldwani': [79.5230, 29.2183],
    'Kashipur': [78.9619, 29.2104],
    'Rudrapur': [79.3959, 28.9760],
};

/**
 * Get coordinates for a city name
 * @param {string} cityName - Name of the city
 * @returns {array|null} - [longitude, latitude] or null if not found
 */
export const getCityCoordinates = (cityName) => {
    if (!cityName) return null;

    // Try exact match first
    if (INDIAN_CITY_COORDINATES[cityName]) {
        return INDIAN_CITY_COORDINATES[cityName];
    }

    // Try case-insensitive match
    const lowerCity = cityName.toLowerCase();
    for (const [city, coords] of Object.entries(INDIAN_CITY_COORDINATES)) {
        if (city.toLowerCase() === lowerCity) {
            return coords;
        }
    }

    // Try partial match (city name contains the key or vice versa)
    for (const [city, coords] of Object.entries(INDIAN_CITY_COORDINATES)) {
        if (city.toLowerCase().includes(lowerCity) || lowerCity.includes(city.toLowerCase())) {
            return coords;
        }
    }

    return null;
};

/**
 * Generate marker colors array
 */
export const MARKER_COLORS = [
    '#4ECDC4', '#FF6B6B', '#45B7D1', '#96CEB4', '#9B59B6',
    '#F39C12', '#E74C3C', '#3498DB', '#2ECC71', '#E91E63',
    '#00BCD4', '#FF5722', '#673AB7', '#009688', '#FFC107',
    '#795548', '#607D8B', '#8BC34A', '#CDDC39', '#FF9800'
];

/**
 * Get a color for a marker by index
 * @param {number} index - Index of the marker
 * @returns {string} - Hex color code
 */
export const getMarkerColor = (index) => {
    return MARKER_COLORS[index % MARKER_COLORS.length];
};

export default INDIAN_CITY_COORDINATES;
